module.exports = __webpack_public_path__ + "static/img/total-bg.f89f50fa.png";